import { Box, Container } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { ShowProgress } from "../../state/ShowProgress";
import { toast } from "react-toastify";
import { validateFields } from "../../common/helper";
import * as yup from "yup";
import { developerApi } from "../../openApi";
import { useDeveloperContext } from "../../hook/useDeveloperContext";
import { ThemeLight } from "../../state/ThemeLight";

const SignIn = () => {
  const navigate = useNavigate();

  const {
    sessionKey,
    handleSessionKey,
    handleUsername,
    handleUserID,
    handleUserEmail,
  } = useDeveloperContext();

  const [, setShowProgress] = useRecoilState(ShowProgress);
  const [themeLight] = useRecoilState(ThemeLight);

  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const [showPassword, setShowPassword] = useState<boolean>(false);

  useEffect(() => {
    if (sessionKey !== undefined && sessionKey !== "") {
      navigate("/myaccount");
    }
  }, [sessionKey]);

  const handleSignin = async () => {
    if (!(await validate())) {
      return false;
    }

    setShowProgress(true);
    developerApi
      .signin({ username, password })
      .then((res) => {
        setShowProgress(false);

        handleUsername(username);
        handleSessionKey(res.data.sessionKey!);
        handleUserID(res.data.userID!);
        handleUserEmail(res.data.userEmail!);
        navigate("/myaccount");
      })
      .catch((err) => {
        toast.error(err.response ? err.response.data.message : err.message, {
          theme: themeLight ? "light" : "dark",
        });
        setShowProgress(false);
      });
  };

  const validate = async () => {
    try {
      await validateFields(
        yup.object().shape({
          username: yup.string().required("Please input the username."),
          password: yup.string().required("Please input the password."),
        }),
        ["username", "password"],
        [username, password]
      );
    } catch (err: any) {
      toast.warn(err.message, { theme: themeLight ? "light" : "dark" });
      return false;
    }

    return true;
  };

  return (
    <Container className="container-xxl py-12 pt-sm-20 pb-sm-32">
      <Box className="col-sm-10 col-md-7 col-lg-5 col-xl-4 card mx-auto p-6">
        <Box className="text-center mb-5">
          <Box className="h4">Sign In</Box>
          <Box className="text-muted mb-0">
            Don't have an account? <Link to="/register">Sign Up</Link>
          </Box>
        </Box>

        <Box className="js-form-message form-group mb-4">
          <Box className="form-label">Username</Box>
          <input
            name="ctl00$ContentPlaceHolder1$txtUserName"
            type="text"
            id="ContentPlaceHolder1_txtUserName"
            className="form-control form-control-lg py-3"
            placeholder="e.g. johndoe"
            data-msg-required="Please enter your Username."
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </Box>

        <Box className="js-form-message form-group mb-4">
          <Box className="d-flex justify-content-between">
            <Box className="form-label">Password</Box>
            <Link className="link-muted" to="/lostpassword">
              Forgot your password?
            </Link>
          </Box>
          <Box className="form-group position-relative">
            <input
              name="ctl00$ContentPlaceHolder1$txtPassword"
              type={showPassword ? "text" : "password"}
              id="ContentPlaceHolder1_txtPassword"
              placeholder="*************"
              className="js-toggle-password form-control form-control-lg py-3"
              data-msg="Your password is invalid. Please try again."
              data-msg-required="Please enter your Password."
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Box
              className="content-center position-absolute top-0 py-1.5"
              title="Password Toggle"
              style={{ right: ".5rem" }}
            >
              <button
                type="button"
                className="btn btn-sm btn-ghost-white"
                id="changePassTarget"
                style={{ width: "2.375rem", height: "2.375rem" }}
                onClick={() => setShowPassword(!showPassword)}
              >
                <VisibilityOffIcon className="text-icon" />
              </button>
            </Box>
          </Box>
        </Box>

        <Box className="js-form-message form-check mb-4">
          <input
            name="ctl00$ContentPlaceHolder1$chkRemember"
            type="checkbox"
            id="ContentPlaceHolder1_chkRemember"
            className="form-check-input"
          />
          <Box
            className="form-check-label"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
          >
            <Box>Remember &amp; Auto Login</Box>
          </Box>
        </Box>
        <Link
          className="btn btn-lg btn-primary w-100 py-3 mt-2"
          to="#"
          onClick={handleSignin}
        >
          LOGIN
        </Link>
      </Box>
    </Container>
  );
};

export default SignIn;
